import { IDocumentFileModel } from '@api/models';
import { deleteDocument } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

interface DeleteDocumentOptions {
    file: IDocumentFileModel;
}

const useDeleteDocumentForm = (options: DeleteDocumentOptions) => {
    const { clientId } = useParams();
    const { file } = options;

    const deleteDocumentMutation = useMutation(() => deleteDocument(clientId, file._id));

    const submit = async () => {
        await deleteDocumentMutation.mutateAsync();
    };

    return {
        isLoading: deleteDocumentMutation.isLoading,
        submit,
    };
};

export default useDeleteDocumentForm;
